module.exports = __webpack_public_path__ + "img/sky.6ea75041.svg";